import React from "react";
import { Panel, SectionGrid, SummaryGrid } from "../AdminAnalyticsCards";
import CssBarChart from "../charts/CssBarChart";
import AdminAnalyticsTable from "../tables/AdminAnalyticsTable";
import { aa, formatDay, formatLabel, formatNumber } from "../adminAnalyticsUtils";
export default function AdminAnalyticsSystemTab({
  data
}) {
  const summary = data?.summary || {};
  const announcements = data?.announcementSummary || {};
  const conflicts = data?.authMigrationConflicts || {};
  return <>
      <SummaryGrid cards={[{
      label: aa("lifecycle_events", "Lifecycle events"),
      value: formatNumber(summary.lifecycleEvents)
    }, {
      label: aa("notifications", "Notifications"),
      value: formatNumber(summary.notifications)
    }, {
      label: aa("unread_notifications", "Unread notifications"),
      value: formatNumber(summary.unreadNotifications)
    }, {
      label: aa("announcements", "Announcements"),
      value: formatNumber(summary.announcements)
    }, {
      label: aa("active_announcements", "Active announcements"),
      value: formatNumber(summary.activeAnnouncements)
    }, {
      label: aa("announcement_dismissals", "Announcement dismissals"),
      value: formatNumber(summary.announcementDismissals)
    }, {
      label: aa("auth_migration_conflicts", "Auth migration conflicts"),
      value: formatNumber(summary.authMigrationConflicts)
    }]} />


      <SectionGrid>
        <CssBarChart title={aa("lifecycle_by_type", "Lifecycle by type")} rows={data?.lifecycleByType} getLabel={row => formatLabel(row?.eventType)} getValue={row => row?.count} />

        <CssBarChart title={aa("lifecycle_by_day", "Lifecycle by day")} rows={data?.lifecycleByDay} getLabel={row => formatDay(row?.day)} getValue={row => row?.count} />

        <Panel title={aa("announcement_summary", "Announcement summary")}>
          <div className="admin-analytics-completion-grid">
            {[[aa("total_announcements", "Total announcements"), announcements.totalAnnouncements], [aa("active_announcements", "Active announcements"), announcements.activeAnnouncements], [aa("dismissals", "Dismissals"), announcements.dismissals], [aa("auth_conflicts", "Auth conflicts"), conflicts.count]].map(([label, value]) => <div className="admin-analytics-completion-item" key={label}>
                <span>{label}</span>
                <strong>{formatNumber(value)}</strong>
              </div>)}
          </div>
        </Panel>
        <AdminAnalyticsTable title={aa("notifications_by_type", "Notifications by type")} rows={data?.notificationsByType} rowKey={row => row?.type} columns={[{
        header: aa("type", "Type"),
        render: row => formatLabel(row?.type)
      }, {
        header: aa("count", "Count"),
        render: row => formatNumber(row?.count)
      }, {
        header: aa("unread", "Unread"),
        render: row => formatNumber(row?.unread)
      }]} />

      </SectionGrid>
    </>;
}
